
export function setLoading(state, brands) {
    state.loading.module = brands;
}
export function setDate(state, date) {
    state.params.date = date;
}
export function setDataReport(state, data) {
    state.reportData = data
}
export function setBranchOffices(state, branch_offices) {
    console.log(branch_offices)
    state.branch_offices = branch_offices.filter(el => ['070', '240', '200', '060'].includes(el.code));
}
export function setResponseAlkostos(state, data) {
    state.formAlokstosResponse = data;
}
export function setFormAlokstosProccessResponse(state, data) {
    state.formAlokstosProccessResponse = data;
}
export function setFinalizeVoucherAlkosto(state,data){
    state.show_pdf  = true
    state.file_name = data.accounting_link
}
export function clearParamsAlkosto(state){
    state.show_pdf  = false
    state.file_name = null
    state.reportData = [];
}




// WEBPACK FOOTER //
// ./src/modules/portfolio_reclassification/mutations.js